export default "__VITE_ASSET__6a492bf6__"